import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Typography, Box, Button, Chip, Pagination } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const PersonalTrainingBlock = ({ trainingsData, onDelete }) => {
  const { trainings } = trainingsData;
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedTrainings = trainings.slice(startIndex, endIndex);

  return (
    <Box>
      {displayedTrainings.map((training) => (
        <Card key={training.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">{training.trainingName}</Typography>
            <Typography variant="body2" color="text.secondary">
              Location: {training.location}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Date: {new Date(training.trainingDate).toLocaleString()}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
              {training.participants.map((participant, index) => (
                <Chip key={index} label={participant} size="small" />
              ))}
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              <Button
                variant="contained"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={() => onDelete(training.id)}
              >
                Remove
              </Button>
            </Box>
          </CardContent>
        </Card>
      ))}
      <Pagination
        count={Math.ceil(trainings.length / ITEMS_PER_PAGE)}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
};

PersonalTrainingBlock.propTypes = {
  trainingsData: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    trainings: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        trainingName: PropTypes.string.isRequired,
        location: PropTypes.string.isRequired,
        trainingDate: PropTypes.string.isRequired,
        participants: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ).isRequired,
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default PersonalTrainingBlock;
